import { render, staticRenderFns } from "./CanteenPickup.vue?vue&type=template&id=20b1637a&lang=pug&"
import script from "./CanteenPickup.vue?vue&type=script&lang=js&"
export * from "./CanteenPickup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports